import React, { useState } from 'react';
import { FaChalkboardTeacher, FaRegClock, FaUserGraduate, FaVideo, FaShoppingCart, FaTimes, FaDownload, FaEnvelope, FaChevronDown } from 'react-icons/fa';
import './PageCss/Courses.css';
import EnrollmentForm from '../components/EnrollmentForm';
import TrainerDetailsPopup from '../components/TrainerDetailsPopup';
import InquiryFormPopup from '../components/CourseInquiryFormPopup';
import img1 from '../img/Course1to1.jpg';
import img2 from '../img/Course2.jpg';
import img3 from '../img/LiveNet.jpg';
import img4 from '../img/Course4.jpg';
import img5 from '../img/tech2.jpg';
import img6 from '../img/Fullstack.png';


const Courses = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [expandedSyllabus, setExpandedSyllabus] = useState(false);

  const [showEnrollmentForm, setShowEnrollmentForm] = useState(false);
  const [courseForEnrollment, setCourseForEnrollment] = useState(null);
  const [showTrainerDetails, setShowTrainerDetails] = useState(false);
  const [showInquiryForm, setShowInquiryForm] = useState(false);

  const handleEnrollClick = (course) => {
    setCourseForEnrollment(course);
    setShowEnrollmentForm(true);
  };

  const handleEnrollmentSubmit = (formData) => {
    // Close all popups
    // setShowEnrollmentForm(false);
    // setSelectedCourse(null);
    
    // Show success message
  };



  const courses = [
    {
      id: 1,
      title: "1-on-1 Personal .NET Mentorship",
      description: "Personalized training tailored to your goals, experience, and schedule in .NET development.",
      image: img1,
      duration: "Flexible (Custom Plan/Per month)",
      students: "100+",
      rating: 5.0,
      price: 15000,
      discountPrice: 12000,
      category: "Personal Training",
      featured: true,
      instructor: "Er. Akash GC",
      level: "Custom (Beginner to Advanced)", 
      isLive: true,
      syllabus: [
        ":Initial Skill Assessment & Goal Setting",
        ":Custom Weekly Roadmap",
        ":Live Code Reviews & Feedback",
        ":Project-Based Learning",
        ":Job Interview Mock Rounds",
      ],
      requirements: ["Commitment to learning", "Stable internet", "Basic system setup"],
      whatYouGet: ["Custom learning path", "Direct mentor support", "Real projects", "Career guidance","Certificate of Completion."]
    },
    {
      id: 2,
      title: "ASP.NET Core Web API Masterclass",
      description: "Build secure, scalable RESTful APIs using ASP.NET Core 8 and Entity Framework Core.",
      image: img2,
      duration: "8 Weeks",
      students: "950+",
      rating: 4.7,
      price: 15000,
      discountPrice: 12000,
      category: ".NET Development",
      featured: true,
      instructor: "Er. Akash GC",
      level: "Intermediate",
      isLive: true,
      syllabus: [
        ": Introduction to ASP.NET Core 8",
        ": Building RESTful APIs",
        ": Entity Framework Core & Database Design",
        ": Authentication & Authorization",
        ": Versioning & Middleware",
        ": Deployment & Best Practices"
      ],
      requirements: ["Basic C# knowledge", "Understanding of HTTP and JSON"],
      whatYouGet: ["Source code access", "Live project", "Interview preparation", "API testing techniques","Certificate of Completion."]
    },
    {
      id: 3,
      title: ".NET Full-Stack Live Training Program",
      description: "Join live classes to learn front-to-back .NET development with Blazor, EF Core, and SQL Server.",
      image: img3,
      duration: "12 Weeks",
      students: "700+",
      rating: 4.9,
      price: 17000,
      discountPrice: 15000,
      category: ".NET Development",
      featured: true,
      instructor: "Er. Akash GC",
      level: "Beginner to Intermediate",
      isLive: true,
      syllabus: [
        ": C# & OOP Concepts",
        ": ASP.NET Core MVC",
        ": Blazor & Razor Pages",
        ": EF Core & Database Relationships",
        ": Authentication with Identity",
        ": REST API Integration",
        ": Admin Dashboard Project",
        ": Deployment on Azure"
      ],
      requirements: ["Windows PC", ".NET SDK installed", "Motivation to learn"],
      whatYouGet: ["Live mentor support", "Doubt-clearing sessions", "Real-world project", "Certificate of Completion"]
    },
    // {
    //   id: 4,
    //   title: "C# & .NET Crash Course for Beginners",
    //   description: "Jumpstart your programming journey with hands-on C# and .NET concepts.",
    //   image: img4,
    //   duration: "6 Weeks",
    //   students: "1500+",
    //   rating: 4.6,
    //   price: 12999,
    //   discountPrice: 9999,
    //   category: ".NET Development",
    //   featured: false,
    //   instructor: "Er. Akash GC",
    //   level: "Beginner",
    //   syllabus: [
    //     "Week 1: Basics of C#",
    //     "Week 2: Object-Oriented Programming",
    //     "Week 3: Collections & LINQ",
    //     "Week 4: Windows Forms & Mini Project"
    //   ],
    //   requirements: ["No prior coding experience", "Visual Studio setup"],
    //   whatYouGet: ["Hands-on labs", "Recorded sessions", "Mini projects", "Job-ready foundation"]
    // },
    // {
    //   id: 5,
    //   title: "Advanced .NET & Clean Architecture",
    //   description: "Design enterprise-level .NET applications using best practices and clean architecture principles.",
    //   image: img5,
    //   duration: "15 Weeks",
    //   students: "500+",
    //   rating: 4.8,
    //   price: 24999,
    //   discountPrice: 19999,
    //   category: ".NET Architecture",
    //   featured: true,
    //   instructor: "Er. Akash GC",
    //   level: "Advanced",
    //   syllabus: [
    //     "Week 1: DDD & SOLID Principles",
    //     "Week 2: Layered Architecture Setup",
    //     "Week 3: CQRS & MediatR Integration",
    //     "Week 4: Dependency Injection & Unit Testing",
    //     "Week 5: Error Handling & Logging",
    //     "Week 6: Final Project & Review"
    //   ],
    //   requirements: ["ASP.NET Core knowledge", "Familiarity with EF Core"],
    //   whatYouGet: ["Reusable project template", "Advanced patterns", "GitHub portfolio", "Interview coaching"]
    // },
    // {
    //   id: 6,
    //   title: "Complete Web Development Bootcamp",
    //   description: "Master full-stack development with modern technologies including React, Node.js, and MongoDB",
    //   image: img6,
    //   duration: "15 Weeks",
    //   students: "1200+",
    //   rating: 4.8,
    //   price: 29999,
    //   discountPrice: 19999,
    //   category: "Web Development",
    //   featured: true,
    //   instructor: "Er. Akash GC",
    //   level: "Beginner to Advanced",
    //   isLive: true,
    //   syllabus: [
    //     "Week 1: HTML5 & CSS3 Fundamentals",
    //     "Week 2: JavaScript ES6+",
    //     "Week 3: React.js Fundamentals",
    //     "Week 4: Advanced React Patterns",
    //     "Week 5: Node.js & Express",
    //     "Week 6: MongoDB & Database Design",
    //     "Week 7: Authentication & Security",
    //     "Week 8: Deployment & Final Project"
    //   ],
    //   requirements: ["Basic computer skills", "No prior programming experience required"],
    //   whatYouGet: ["Certificate of completion", "Lifetime access", "Project portfolio", "Career support"]
    // },
  ];

  const openCourseDetails = (course) => {
    setSelectedCourse(course);
    setExpandedSyllabus(false);
    document.body.style.overflow = 'hidden';
  };

  const closeCourseDetails = () => {
    setSelectedCourse(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div id="courses" className="courses-section">
      <div className="courses-container">
        <div className="courses-header" data-aos="fade-up">
          <h2>Our Courses</h2>
          <p className="courses-subtitle">
            Transform your skills with our industry-leading programs
          </p>
        </div>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <div 
              key={course.id} 
              className={`course-card ${course.featured ? 'featured' : ''}`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {course.featured && <div className="featured-badge">Featured</div>}
              {course.discountPrice && (
                <div className="discount-badge">
                  Save RS.{course.price - course.discountPrice}
                </div>
              )}
              <div className="course-image-container">
                <img src={course.image} alt={course.title} className="course-image" />
              </div>
              <div className="course-content">
                <span className="course-category">{course.category}</span>
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>
                
               <div className="course-meta">
                  <div className="meta-item">
                    <FaRegClock className="meta-icon" />
                    <span>{course.duration}</span>
                  </div>
                  <div className="meta-item">
                    {course.isLive ? (
                      <span className="live-badge">
                        <span className="live-pulse"></span>
                        Live Class
                      </span>
                    ) : (
                      <span className="recorded-badge">
                        <FaVideo className="meta-icon" />
                        Recorded
                      </span>
                    )}
                  </div>
                </div>
                
                <div className="course-pricing">
                  {course.discountPrice ? (
                    <>
                      <span className="original-price">RS.{course.price}</span>
                      <span className="discount-price">RS.{course.discountPrice}</span>
                    </>
                  ) : (
                    <span className="regular-price">RS.{course.price}</span>
                  )}
                </div>
                
                <div className="course-actions">
                  <button className="details-button" onClick={() => openCourseDetails(course)}>
                    View Details
                  </button>
                  <button className="enroll-button" onClick={() => handleEnrollClick(course)}>
                    <FaShoppingCart className="button-icon" />
                    Enroll Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Course Details Popup */}
      {selectedCourse && (
        <div className="course-popup-overlay">
          <div className="course-popup">
            <button className="close-popup" onClick={closeCourseDetails}>
              <FaTimes />
            </button>
            
            <div className="popup-header">
              <div className="popup-image-container">
                <img src={selectedCourse.image} alt={selectedCourse.title} />
              </div>
              <div className="popup-header-content">
                <span className="popup-category">{selectedCourse.category}</span>
                <h3>{selectedCourse.title}</h3>
                <div className="popup-meta">
                  <span><FaUserGraduate /> {selectedCourse.instructor}</span>
                  <span><FaRegClock /> {selectedCourse.duration}</span>
                  {selectedCourse.isLive ? (
                      <span className="live-badge">
                        <span className="live-pulse"></span>
                        Live Class
                      </span>
                    ) : (
                      <span className="recorded-badge">
                        <FaVideo className="meta-icon" />
                        Recorded
                      </span>
                    )}
                  <span>Level: {selectedCourse.level}</span>
                </div>
                
                <div className="popup-pricing">
                  {selectedCourse.discountPrice ? (
                    <>
                      <span className="original-price">RS.{selectedCourse.price}</span>
                      <span className="discount-price">RS.{selectedCourse.discountPrice}</span>
                    </>
                  ) : (
                    <span className="regular-price">RS.{selectedCourse.price}</span>
                  )}
                </div>
                
                <div className="popup-actions">
                  <button className="primary-action" onClick={() => handleEnrollClick(selectedCourse)}>
                    <FaShoppingCart /> Enroll Now
                  </button>
                  <button className="secondary-action" onClick={() => setShowInquiryForm(true)}>
                    <FaEnvelope /> Send Inquiry
                  </button>
                  <button className="tertiary-action" onClick={() => setShowTrainerDetails(true)}>
                    <FaChalkboardTeacher /> Trainer Details
                  </button>
                </div>
              </div>
            </div>
            
            <div className="popup-content">
              <div className="popup-section">
                <h4>Course Description</h4>
                <p>{selectedCourse.description}</p>
              </div>
              
              <div className="popup-section">
                <h4>What You'll Learn</h4>
                <ul className="benefits-list">
                  {selectedCourse.whatYouGet.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              
              <div className="popup-section">
                <div className="syllabus-header" onClick={() => setExpandedSyllabus(!expandedSyllabus)}>
                  <h4>Course Syllabus</h4>
                  <FaChevronDown className={`chevron ${expandedSyllabus ? 'expanded' : ''}`} />
                </div>
                {expandedSyllabus && (
                  <ul className="syllabus-list">
                    {selectedCourse.syllabus.map((item, index) => (
                      <li key={index}>
                        <span className="week">{index + 1}</span>
                        <span className="topic">{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
                <button className="download-syllabus">
                  <FaDownload />   Full syllabus will be emailed after enrollment (No payment needed)
                </button>
              </div>
              
              <div className="popup-section">
                <h4>Requirements</h4>
                <ul className="requirements-list">
                  {selectedCourse.requirements.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}


            {/* Enrollment Form Popup */}
        {showEnrollmentForm && (
        <EnrollmentForm 
          courseTitle={courseForEnrollment?.title} 
          coursePrice={courseForEnrollment?.price}
          onClose={() => setShowEnrollmentForm(false)}
        />
      )}

        {showTrainerDetails && (
          <TrainerDetailsPopup onClose={() => setShowTrainerDetails(false)} />
        )}

        {showInquiryForm && (
          <InquiryFormPopup 
            courseTitle={selectedCourse?.title} 
            onClose={() => setShowInquiryForm(false)}
          />
        )}
    </div>
  );
};

export default Courses;